var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"theme-switch"},[_c('i',{staticClass:"uil uil-moon"}),_c('value-switch',{on:{"changed":_vm.handleThemeSelect}}),_c('i',{staticClass:"uil uil-sun"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }